import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice" 
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Telemedicine App Development",
      slug:""
    },
  ]
}

export default function TelemedBanner() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="custom-app-banner ecom-banner header-gap">
        <div className="custom-banner-img">
          <img src="./assets/home/telemed-banner.webp" alt="banner" className='img-responsive'/>
        </div>

        <div className="custom-app-head text-center">
          <label>AI-Powered</label>
          <h1 className="heading center-heading"><span>Empowering Healthcare </span> 
          with Telemedicine Solutions</h1>
          <p className="sub-heading">Experience the future of healthcare with Mobility Infotech’s advanced telemedicine platform, enabling seamless connections between providers and patients for superior care anytime, anywhere.</p>
          <small>21 Days Free Trial | No Credit Card Required</small>
          <Breadcrumb breadcrumbData={breadcrumbData}/>
          <Link  onClick={() => dispatch(openPopup())}  className="default-btn animated-btn">
          book a demo
          </Link> 
        </div>
      </section>
    </>
  )
}
